import useMediaQuery from '@mui/material/useMediaQuery'
import { getStyles } from '@user/components/Settings/PendingLeadSettings/styles'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import React from 'react'
import { LeadTypeAssignmentRule } from '@user/components/Settings/PendingLeadSettings/hooks/useData'
import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip'

export type Props = {
  leadTypeAssignmentRules: LeadTypeAssignmentRule[]
}

export const ApplicableRules = ({ leadTypeAssignmentRules }: Props) => {
  const isMobile = useMediaQuery('(max-width:900px)')
  const styles = getStyles(isMobile)

  return (
    <Paper variant="outlined" sx={styles.paper}>
      <Typography variant="subtitle3">Applicable Rules</Typography>

      {leadTypeAssignmentRules.map(
        ({ assignmentRuleId, assignmentRuleName, types }) => (
          <Stack
            key={assignmentRuleId}
            display="flex"
            direction="row"
            gap="0 20px"
            flexWrap="wrap"
            px="18px"
            py="16px"
            alignItems="center"
            border="1px solid #e2e5ea"
            borderRadius="8px"
            justifyContent="space-between"
            mt={1}
          >
            <Typography variant="subtitle1" fontSize="14px">
              {assignmentRuleName}
            </Typography>

            <Chip label={types.join(', ')} color="primary" size="small" />
          </Stack>
        ),
      )}
    </Paper>
  )
}
